import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { hasPermission } from 'Components/Permissions/utils'
import { isRequestCreator } from './helpers'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayNames = 'RugCardDetailedActionsContainer'

    static propTypes = {
      createRequest: PropTypes.func.isRequired,
      deleteRequest: PropTypes.func.isRequired,
      rug: PropTypes.object.isRequired,
      showCreateReservationModal: PropTypes.func.isRequired,
      toggleIsMasterpiece: PropTypes.func.isRequired,
      toggleMarkedForDesigners: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
      userPermissions: PropTypes.array.isRequired,
    }

    createRequest = () => {
      const { createRequest, rug, user } = this.props

      createRequest(rug.id, user.id)
    }

    deleteRequest = () => {
      const { deleteRequest, rug, user } = this.props
      const activeRequest = rug.requests.find(r => !r.fulfilled && !r.deleted)

      if (activeRequest) {
        deleteRequest(activeRequest.id, user.id)
      }
    }

    requestActionLink = () => {
      const { rug, user, userPermissions } = this.props
      const activeRequest = rug.requests.find(r => !r.fulfilled && !r.deleted)

      const canDeleteRequest =
        isRequestCreator(activeRequest, user) || hasPermission('rug.action.deleteRequestDesignerPicture', userPermissions)

      if (hasPermission('rug.action.requestDesignerPicture', userPermissions) && !activeRequest) {
        return true
      }

      if (canDeleteRequest && activeRequest) {
        return true
      }

      return false
    }

    toggleIsMasterpiece = () => {
      const { rug, toggleIsMasterpiece } = this.props

      toggleIsMasterpiece(rug.id)
    }

    toggleMarkedForDesigners = () => {
      const { rug, toggleMarkedForDesigners } = this.props

      toggleMarkedForDesigners(rug.id)
    }

    render() {
      return (
        <WrappedComponent
          createRequest={this.createRequest}
          deleteRequest={this.deleteRequest}
          requestAsLink={this.requestActionLink()}
          rug={this.props.rug}
          showCreateReservationModal={this.props.showCreateReservationModal}
          toggleIsMasterpiece={this.toggleIsMasterpiece}
          toggleMarkedForDesigners={this.toggleMarkedForDesigners}
          user={this.props.user}
          userPermissions={this.props.userPermissions}
        />
      )
    }
  }

  return Container
}
